import { Link } from "react-router-dom";
import {
  Inventory2Outlined,
  PointOfSaleOutlined,
  CloudOutlined,
  QrCodeScannerOutlined,
  ArrowForward,
  Language,
  EmailOutlined,
  LocationOnOutlined,
  PhoneOutlined,
  KeyboardArrowUp,
  SecurityOutlined,
  VerifiedOutlined,
} from "@mui/icons-material";
import "./UniverseFooter.css";

const UniverseFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="universeFooter">
      {/* ================================================================
          FOOTER TOP / CTA
      ================================================================= */}

      <section className="universeFooterCta">
        <div className="universeFooterCtaGlow universeFooterCtaGlowOne" />
        <div className="universeFooterCtaGlow universeFooterCtaGlowTwo" />

        <div className="universeFooterCtaContent">
          <div className="universeFooterCtaIcon">
            <Inventory2Outlined />
          </div>

          <div className="universeFooterCtaText">
            <span className="universeFooterEyebrow">
              READY TO TAKE CONTROL?
            </span>

            <h2>
              Build a smarter way to
              <span> manage your business.</span>
            </h2>

            <p>
              Bring your inventory, sales, payments, products and business
              operations together with Universe Inventory Management.
            </p>
          </div>

          <div className="universeFooterCtaActions">
            <Link to="/register" className="universeFooterPrimaryButton">
              <span>Get Started Free</span>
              <ArrowForward />
            </Link>

            <Link
              to="/solutions/all-solutions"
              className="universeFooterSecondaryButton"
            >
              Explore Universe
            </Link>
          </div>
        </div>
      </section>

      {/* ================================================================
          MAIN FOOTER
      ================================================================= */}

      <div className="universeFooterMain">
        <div className="universeFooterContainer">
          {/* ============================================================
              BRAND COLUMN
          ============================================================ */}

          <div className="universeFooterBrand">
            <Link to="/" className="universeFooterLogo">
              <span className="universeFooterLogoMark">
                <Inventory2Outlined />
              </span>

              <span className="universeFooterLogoText">
                <strong>Universe</strong>
                <small>Inventory</small>
              </span>
            </Link>

            <p className="universeFooterBrandDescription">
              A modern inventory management ecosystem built to help businesses
              control stock, manage sales, monitor transactions, and operate
              smarter from anywhere.
            </p>

            <div className="universeFooterBrandBadge">
              <VerifiedOutlined />
              <span>Built for modern businesses</span>
            </div>

            <div className="universeFooterContactMini">
              <a href="mailto:support@universeinventory.com">
                <EmailOutlined />
                <span>support@universeinventory.com</span>
              </a>

              <div>
                <LocationOnOutlined />
                <span>Built for businesses worldwide</span>
              </div>
            </div>
          </div>

          {/* ============================================================
              PRODUCTS
          ============================================================ */}

          <div className="universeFooterColumn">
            <h3>Products</h3>

            <Link to="/solutions/all-solutions">
              <Inventory2Outlined />
              <span>
                Universe Inventory
                <small>Complete inventory management</small>
              </span>
            </Link>

            <Link to="/store/universe-mobile/application/universe-pos">
              <PointOfSaleOutlined />
              <span>
                Universe POS
                <small>Fast point-of-sale operations</small>
              </span>
            </Link>

            <Link to="/store/universe-mobile/application/unicloud">
              <CloudOutlined />
              <span>
                UniCloud
                <small>Real-time business notifications</small>
              </span>
            </Link>

            <Link to="/store/universe-mobile/application/universe-scanner">
              <QrCodeScannerOutlined />
              <span>
                Universe Scanner
                <small>Scan with your mobile device</small>
              </span>
            </Link>
          </div>

          {/* ============================================================
              SOLUTIONS
          ============================================================ */}

          <div className="universeFooterColumn">
            <h3>Solutions</h3>

            <Link to="/solutions/all-solutions">Inventory Management</Link>

            <Link to="/solutions/industries">Business Solutions</Link>

            <Link to="/company/features">Features</Link>

            <Link to="/pricing">Pricing</Link>

            <Link to="/solutions/point-of-sale">Point of Sale</Link>

            <Link to="/solutions">Explore Solutions</Link>
          </div>

          {/* ============================================================
              RESOURCES
          ============================================================ */}

          <div className="universeFooterColumn">
            <h3>Resources</h3>

            <Link to="/learning">Learning Center</Link>

            <Link to="/blog">Blog & Updates</Link>

            <Link to="/api">API Documentation</Link>

            <Link to="/support">Support Center</Link>

            <Link to="/contact-us">Contact Us</Link>

            <Link to="/report">Report a Problem</Link>
          </div>

          {/* ============================================================
              COMPANY
          ============================================================ */}

          <div className="universeFooterColumn">
            <h3>Company</h3>

            <Link to="/about-us">About Universe</Link>

            <Link to="/contact-us">Contact Us</Link>

            <Link to="/blog">News & Updates</Link>

            <Link to="/terms">Terms of Service</Link>

            <Link to="/privacy">Privacy Policy</Link>

            <Link to="/cookies">Cookie Settings</Link>

            <Link to="/administration/staff-login">Admin Staff</Link>
          </div>
        </div>

        {/* ================================================================
            NEWSLETTER
        ================================================================= */}

        <div className="universeFooterNewsletter">
          <div className="universeFooterNewsletterContainer">
            <div className="universeFooterNewsletterInfo">
              <div className="universeFooterNewsletterIcon">
                <EmailOutlined />
              </div>

              <div>
                <span className="universeFooterNewsletterEyebrow">
                  STAY IN THE UNIVERSE
                </span>

                <h3>Get inventory insights & product updates.</h3>

                <p>
                  Receive useful business insights, product announcements,
                  feature updates and important Universe news.
                </p>
              </div>
            </div>

            <form
              className="universeFooterNewsletterForm"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="universeFooterEmailInput">
                <EmailOutlined />

                <input
                  type="email"
                  placeholder="Enter your email address"
                  aria-label="Email address"
                />
              </div>

              <button type="submit">
                <span>Subscribe</span>
                <ArrowForward />
              </button>
            </form>
          </div>
        </div>

        {/* ================================================================
            TRUST BAR
        ================================================================= */}

        <div className="universeFooterTrust">
          <div className="universeFooterContainer">
            <div className="universeFooterTrustItem">
              <SecurityOutlined />

              <div>
                <strong>Security focused</strong>
                <span>Your business data matters.</span>
              </div>
            </div>

            <div className="universeFooterTrustItem">
              <CloudOutlined />

              <div>
                <strong>Connected ecosystem</strong>
                <span>Stay connected across your operations.</span>
              </div>
            </div>

            <div className="universeFooterTrustItem">
              <VerifiedOutlined />

              <div>
                <strong>Built for business</strong>
                <span>Designed around real business workflows.</span>
              </div>
            </div>

            <button
              type="button"
              className="universeFooterBackTop"
              onClick={scrollToTop}
              aria-label="Back to top"
            >
              <KeyboardArrowUp />
              <span>Back to top</span>
            </button>
          </div>
        </div>

        {/* ================================================================
            BOTTOM BAR
        ================================================================= */}

        <div className="universeFooterBottom">
          <div className="universeFooterContainer">
            <div className="universeFooterCopyright">
              <span>© 2026 Universe Inventory Management System.</span>

              <span className="universeFooterDot">•</span>

              <span>All rights reserved.</span>
            </div>

            <div className="universeFooterLegal">
              <Link to="/terms">Terms</Link>

              <Link to="/privacy">Privacy</Link>

              <Link to="/cookies">Cookies</Link>
            </div>

            <div className="universeFooterLanguage">
              <Language />

              <span>English</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default UniverseFooter;
